module.exports = __webpack_public_path__ + "media/customizations/viridian/logo-34207001df863b3c6c439f3f35e34f4b.png";